import '@/plugins/axios'
import { getBaseUrl } from '@/utils/endpoint'

export function getData(params) {
  return window.axios.get(getBaseUrl() + '/outlet', { params: params })
}

export function getDataDetail(id, params = {}) {
  return window.axios.get(getBaseUrl() + '/outlet/' + id, { params: params })
}
